<script lang="ts">
  /**
   * This Vue component dynamically renders either `ArticleCard` an ad component from 'AdHandler' component
   * based on the provided props.
   * It allows the use of a single component in the layout, deferring the decision of which component
   * to render until the last possible moment.
   *
   */
  import { defineComponent, h } from 'vue'
  import { ArticleCard } from '#components'
  import AdHandler from '../AdHandler/AdHandler.vue'

  const propsOptions = {
    ad: Boolean,
    adType: {
      type: String,
      default: '',
    },
  }

  export default defineComponent({
    props: propsOptions,
    setup(props) {
      return () => {
        const Component: Component =
          props.ad && props.adType !== 'direct' ? AdHandler : ArticleCard
        return h(Component, { ...props })
      }
    },
  })
</script>
